export default{"COMMON_PUBLIC_FRONTEND_ROOT_PATH":""}